import { AnyAction, ThunkAction } from "@reduxjs/toolkit";
import { FinanceModel } from "../../models/FinanceModel";
import FinanceService from "../../services/FinanceService";
import FinanceSlice from "../slices/FinanceSlice";
import { RootState } from "../store";

export const FinanceActions = FinanceSlice.actions;
export const fetchFinances = (): ThunkAction<
  void,
  RootState,
  unknown,
  AnyAction
> => {
  return async (dispatch) => {
    dispatch(FinanceActions.setIsFinancesFetching(true));
    const response: FinanceModel[] = await FinanceService.getAllFinances();
    dispatch(FinanceActions.setFinances(response));
    dispatch(FinanceActions.setIsFinancesFetching(false));
  };
};
export const fetchParticularFinance = (
  Finance_id: number
): ThunkAction<void, RootState, unknown, AnyAction> => {
  return async (dispatch, getState) => {
    const response: FinanceModel = await FinanceService.getParticularFinance(
      Finance_id
    );
    dispatch(FinanceActions.setParticularFinance(response));
  };
};
